import React, { useState, useEffect } from 'react';
import { createPortal } from 'react-dom';
import { Button, InputNumber, Radio, Typography, DatePicker, Tree, Select, Empty, Spin, notification, Row, Col } from 'antd';
import moment from 'moment';
import axios from 'axios';
import { ArrowLeftOutlined, CalendarOutlined, ClockCircleOutlined, FieldTimeOutlined, LockOutlined, PercentageOutlined, SaveOutlined, SettingOutlined, TrophyOutlined, UsergroupAddOutlined } from '@ant-design/icons';
import StickyBox from "react-sticky-box";
import { Levels } from '../../constants'
import './AssessmentAssignPanel.css';


const { Text } = Typography;
const { RangePicker } = DatePicker;
const { Option } = Select

export default function AssessmentAssignTool(props) {
   // const assOptionState = useSelector(state => state.assOptionState)
   // const dispatch = useDispatch();   
   const [expandedKeys, setExpandedKeys] = useState([]);
   const [checkedKeys, setCheckedKeys] = useState([]);
   const [selectedKeys, setSelectedKeys] = useState([]);
   // const [autoExpandParent, setAutoExpandParent] = useState(true);
   const [treeData, setTreeData] = useState([]);
   const [studentListLoading, setStudentListLoading] = useState(false);

   const [manualSaveSlotReady, setManualSaveSlotReady] = useState(false);
   
   useEffect(() => {
      if (props.manualSaveSlotId) {
         setManualSaveSlotReady(true);
      }
   }, [props.manualSaveSlotId]);

   const dateFormat = 'MMM D, YYYY h:mm a';
   const customFormat = value => `${value.format(dateFormat)}`;

   var ass_options = props.options;

   useEffect(() => {
      // Utils.verifyJwt();

      if (props.options.level !== undefined && props.options.level !== null && props.options.level !== 0) {
         ass_options.level = props.options.level;
         setExpandedKeys([]);
         setStudentListLoading(true);

         axios.get(`${process.env.REACT_APP_API_ASSESSMENT}/studentlistperleveljson?level=${props.options.level}`).then((response) => {
            if (response.data) {
               const data = response.data;

               setTreeData(data);

               // var students = props.options.assigned_students.split(',');
               // const finallist = students.map(e => 's_' + e);
               // setCheckedKeys(finallist);

               var students = props.options.assigned_students_with_section.split(',');
               setCheckedKeys(students);
            }
            setStudentListLoading(false);
         }, (error) => {
            setStudentListLoading(false);
            console.log(error.message);
         });

         props.parentCallback(ass_options);
      }

   }, [props.options.id]);

   const onExpand = (expandedKeysValue) => {
      //console.log('onExpand', expandedKeysValue); // if not set autoExpandParent to false, if children expanded, parent can not collapse.
      // or, you can remove all expanded children keys.

      setExpandedKeys(expandedKeysValue);
   };

   const onCheck = (checkedKeysValue) => {
      //console.log('onCheck', checkedKeysValue);
      setCheckedKeys(checkedKeysValue);

      //-- (start) with section ------------------------------
      const selectedStudsWithSection = checkedKeysValue.filter((e) => {
         return e.includes('_');
         //return e.includes('|');
      });

      ass_options.assigned_students_with_section = selectedStudsWithSection.join(',');

      //-- Remove the section part
      for (var i = 0; i < selectedStudsWithSection.length; i++) {
         selectedStudsWithSection[i] = selectedStudsWithSection[i].substring(selectedStudsWithSection[i].indexOf('_') + 1, selectedStudsWithSection[i].length);
         //selectedStudsWithSection[i] = selectedStudsWithSection[i].substring(selectedStudsWithSection[i].indexOf('|') + 1, selectedStudsWithSection[i].length);
      }

      var selected = [...new Set(selectedStudsWithSection)]; //-- Remove duplicate students
      ass_options.assigned_students = selected.join(',');
      //-- (end) with section ------------------------------

      // //-- (start) without section ------------------------------
      // const selectedStuds = checkedKeysValue.filter((e) => {
      //    return e.includes('s_');
      // });

      // ass_options.assigned_students = selectedStuds.join(',');
      // ass_options.assigned_students = ass_options.assigned_students.replace(/s_/g, '');
      // //-- (end) without section ------------------------------

      props.parentCallback(ass_options);
   };

   const onSelect = (selectedKeysValue, info) => {
      //console.log('onSelect', info);
      setSelectedKeys(selectedKeysValue);
   };

   const handleClose = (event) => {
      // props.parentCallback(ass_options);
      props.backCallback(ass_options);
   }

   const onDateTimeChange = (value, dateString) => {
      console.log('Selected Time: ', value);
      console.log('Formatted Selected Time: ', dateString);
      ass_options.start_date = dateString[0];
      ass_options.end_date = dateString[1];
      props.parentCallback(ass_options);
   }

   const onDurationChange = (val) => {
      ass_options.duration = val.toString();
      // ass_options = dispatch(update_ass_option_data(assOptions));
      // ass_options = assOptionState;
      props.parentCallback(ass_options);
   }

   const onPercentChange = (val) => {
      ass_options.passing_percentage = val.toString();
      props.parentCallback(ass_options);
   }

   const onAttemptsChange = (val) => {
      ass_options.allowed_attempts = val.toString();
      props.parentCallback(ass_options);
   }

   const onShowResultChange = (e) => {
      ass_options.allow_result_viewing = e.target.value;
      props.parentCallback(ass_options);
   }

   const onTimerChange = (e) => {
      ass_options.enable_timer = e.target.value;
      props.parentCallback(ass_options);
   }

   const onAutoLockChange = (e) => {
      ass_options.enable_auto_lock = e.target.value;
      props.parentCallback(ass_options);
   }

   const onRandomizeQuestionsChange = (val) => {
      ass_options.randomize_questions = parseInt(val.target.value);
      props.parentCallback(ass_options);
   }

   const handleSave = () => {
      // Add validation checks here
      if (!ass_options.start_date || !ass_options.end_date) {
         // alert('Please set a valid schedule for the assignment.');
         notification.error({
            message: `Assessment Assignment`,
            description: 'Please set a valid schedule for the assignment.' 
         });
         return;
      }

      try {
         // Save to local storage with error handling
         localStorage.setItem("_assoptions", JSON.stringify(ass_options));

         // Log saved data for debugging purposes (optional)
         console.log(localStorage.getItem("_assoptions"));

         props.saveCallback(ass_options); // Call the save callback to handle further processing
         
      } catch (error) {
         console.error("Failed to save assignment options:", error);
         notification.error({
            message: `Assessment Assignment`,
            description: 'An error occurred while saving the assignment. Please try again.' 
         });
      }
   };

   // const handleSave = () => {
   //    localStorage.setItem("_assoptions", JSON.stringify(ass_options));
   //    console.log(localStorage.getItem("_assoptions"));
   //    props.saveCallback(ass_options);
   // }

   const handleLevelChange = (val) => {
      // setAssLevel(val);
      ass_options.level = val;
      setTreeData([]);
      setCheckedKeys([]);
      setExpandedKeys([]);

      if (val === undefined || val === null) {
         setStudentListLoading(false);
         props.parentCallback(ass_options);
         return;
      }

      setStudentListLoading(true);
      axios.get(`${process.env.REACT_APP_API_ASSESSMENT}/studentlistperleveljson?level=${val}`).then((response) => {
         if (response.data) {
            const data = response.data;
            setTreeData(data);
         }
         setStudentListLoading(false);
      }, (error) => {
         setStudentListLoading(false);
         console.log(error.message);
      });

      props.parentCallback(ass_options);
   }

   const selectedStudentCount = checkedKeys.filter((key) => key.includes('_')).length;
   const showRandomizeQuestions = ass_options.mode === 2 || ass_options.mode === '2';
   const hasSelectedLevel = props.options.level !== undefined && props.options.level !== null && props.options.level !== '' && props.options.level !== 0;

   const renderManualSaveRow = () => (
      <Row className="assessment-assign-drawer-save-row" style={{ paddingBottom: 12 }}>
         <Col span={24} className="gutter-row">
            <Button className='button-shadow assessment-assign-drawer-save-button' type='primary' block shape='round' onClick={() => handleSave()}><Text ellipsis style={{ color: "#fff" }}><SaveOutlined />&nbsp;Save</Text></Button>
         </Col>
      </Row>
   );

   return (
      <div className="assessment-assign-panel">
         <section className="assessment-assign-section">
            <div className="assessment-assign-section-header">
               <span className="assessment-assign-section-icon"><SettingOutlined /></span>
               <div>
                  <Text className="assessment-assign-kicker">Options</Text>
                  <h3>Assignment Settings</h3>
               </div>
            </div>

            <div className="assessment-assign-options-grid">
               <label className="assessment-assign-field">
                  <span><ClockCircleOutlined /> Duration</span>
                  <InputNumber
                     value={ass_options.duration}
                     min="1"
                     onChange={(val) => onDurationChange(val)}
                  />
               </label>
               <label className="assessment-assign-field">
                  <span><PercentageOutlined /> Passing %</span>
                  <InputNumber
                     value={ass_options.passing_percentage}
                     min="30"
                     onChange={(val) => onPercentChange(val)}
                  />
               </label>
               <label className="assessment-assign-field">
                  <span><TrophyOutlined /> Attempts</span>
                  <InputNumber
                     value={ass_options.allowed_attempts}
                     min="1"
                     onChange={(val) => onAttemptsChange(val)}
                  />
               </label>
               {showRandomizeQuestions &&
                  <label className="assessment-assign-field">
                     <span><FieldTimeOutlined /> Randomize</span>
                     <Radio.Group
                        name='randomize_question'
                        defaultValue={'0'}
                        value={ass_options.randomize_questions.toString()}
                        buttonStyle='solid'
                        onChange={(e) => onRandomizeQuestionsChange(e)}
                     >
                        <Radio.Button value="1">Yes</Radio.Button>
                        <Radio.Button value="0">No</Radio.Button>
                     </Radio.Group>
                  </label>
               }
               <label className="assessment-assign-field">
                  <span><SaveOutlined /> Show Result</span>
                  <Radio.Group
                     name='show_result'
                     value={ass_options.allow_result_viewing}
                     buttonStyle='solid'
                     onChange={(e) => onShowResultChange(e)}
                  >
                     <Radio.Button value="1">Yes</Radio.Button>
                     <Radio.Button value="0">No</Radio.Button>
                  </Radio.Group>
               </label>
               <label className="assessment-assign-field">
                  <span><FieldTimeOutlined /> Timer</span>
                  <Radio.Group
                     name='timer'
                     value={ass_options.enable_timer}
                     buttonStyle='solid'
                     onChange={(e) => onTimerChange(e)}
                  >
                     <Radio.Button value="1">On</Radio.Button>
                     <Radio.Button value="0">Off</Radio.Button>
                  </Radio.Group>
               </label>
               <label className="assessment-assign-field">
                  <span><LockOutlined /> Auto Lock</span>
                  <Radio.Group
                     name='auto_lock'
                     value={(ass_options.enable_auto_lock ?? ass_options.auto_lock_enabled ?? '0').toString()}
                     buttonStyle='solid'
                     onChange={(e) => onAutoLockChange(e)}
                  >
                     <Radio.Button value="1">On</Radio.Button>
                     <Radio.Button value="0">Off</Radio.Button>
                  </Radio.Group>
               </label>
               <label className="assessment-assign-field is-wide">
                  <span><CalendarOutlined /> Schedule</span>
                  <RangePicker
                     showTime={{ format: 'hh:mm A', use12Hours: true }}
                     format={customFormat}
                     onChange={onDateTimeChange}
                     disabledDate={(current) => current.isBefore(moment().subtract(1, "day"))}
                     value={
                        [ass_options.start_date !== "" ? moment(ass_options.start_date) : "",
                        ass_options.end_date !== "" ? moment(ass_options.end_date) : ""]
                     }
                  />
               </label>
            </div>
         </section>

         <section className="assessment-assign-section">
            <div className="assessment-assign-section-header">
               <span className="assessment-assign-section-icon"><UsergroupAddOutlined /></span>
               <div>
                  <Text className="assessment-assign-kicker">Recipients</Text>
                  <h3>Assign Students</h3>
               </div>
               <span className="assessment-assign-count">{selectedStudentCount}</span>
            </div>
            <div className="assessment-assign-recipient-card">
               <Select
                  showArrow
                  size='default'
                  className="assessment-assign-level-select"
                  allowClear
                  placeholder="Select Level"
                  onChange={(val) => handleLevelChange(val)}
                  value={props.options.level}
               >
                  {Levels.map(({ value, name }, idx) => {
                     return <Option value={value}>{name}</Option>
                  })}
               </Select>
               {studentListLoading
                  ? <div className="assessment-assign-empty-state"><Spin /></div>
                  : hasSelectedLevel && treeData.length > 0
                     ?
                  <div className="assessment-assign-tree-shell">
                     <Tree
                        checkable
                        onExpand={onExpand}
                        expandedKeys={expandedKeys}
                        autoExpandParent={true}
                        onCheck={onCheck}
                        checkedKeys={checkedKeys}
                        onSelect={onSelect}
                        selectedKeys={selectedKeys}
                        treeData={treeData}
                        defaultExpandParent={true}
                     />
                  </div>
                     :
                     hasSelectedLevel &&
                  <div className="assessment-assign-empty-state">
                     <Empty image="../images/brainee_mascot.png" description="No students found" />
                  </div>
               }

               {props.manualSaveSlotId && manualSaveSlotReady && document.getElementById(props.manualSaveSlotId)
                  ? createPortal(renderManualSaveRow(), document.getElementById(props.manualSaveSlotId))
                  : (!props.manualSaveSlotId ? renderManualSaveRow() : null)
               }
            </div>
         </section>

         {/* <StickyBox bottom={true} className="assessment-assign-sticky-action">
            <Button className='assessment-assign-save-btn' type='primary' block shape='round' onClick={props.mode === "drawer" ? handleSave : handleClose}>
               {props.mode === "drawer" ? <SaveOutlined /> : <ArrowLeftOutlined />}
               <Text ellipsis>{props.mode === "drawer" ? "Save Assignment" : "Back"}</Text>
            </Button>
         </StickyBox> */}
      </div>
   )
}

